// Page heading / breadcrumb label for a URL path segment. The panel derives headings from the
// path, so segments whose heading should differ from the path name are listed here (the
// sidebar uses the same wording in routes.js).
const TITLE_OVERRIDES = {
  "payment-link-generator": "Generate Payment Link",
};

export function pageTitle(segment = "") {
  return TITLE_OVERRIDES[segment] || segment.replace(/-/g, " ");
}
